import { createContext, useCallback, useContext, useEffect, useState, createElement } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const Ctx = createContext({ settings: null, reload: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const reload = useCallback(() => axios.get(`${API}/public/settings`).then((r) => setSettings(r.data)), []);
  useEffect(() => { reload(); }, [reload]);
  return createElement(Ctx.Provider, { value: { settings, reload } }, children);
}

export const useSettings = () => useContext(Ctx);
